import React from 'react';

import { PORTAL_GATE_ALERT } from '@webtrader/core/constants/portal';
import i18n from '@webtrader/core/i18n';
import { EAlertSubmitType, IMobileAlertParams } from '@webtrader/core/services/alert';
import { checkIsNative } from '@webtrader/core/validators/device';

import { checkIsIos, defaultModalOpenDelay } from '@/utils/device';

import { removeGate, teleportToGate } from '../Portal/PortalUtil';
import AbsoluteModal from './AbsoluteModal';
import WebModal from './WebModal';

const mapSubmitTypeToText = (submitType?: EAlertSubmitType) => {
  switch (submitType) {
    case EAlertSubmitType.CANCEL:
      return i18n.t('CANCEL');
    default:
      return i18n.t('OK');
  }
};

const AlertManager = () => {
  return {
    alert: (params: IMobileAlertParams) => {
      const {
        type = 'success',
        title = '',
        id,
        message,
        submitType,
        noButton,
        absoluteAlert,
        refresh = false,
        onAfterCancel,
        onBeforeCancel,

        shouldDelay = false,
        customDelaySeconds = defaultModalOpenDelay
      } = params;

      onBeforeCancel?.();

      // delay not required here as AbsoluteModal is not implemented with the native Modal component
      if (absoluteAlert) {
        teleportToGate(
          PORTAL_GATE_ALERT,
          <AbsoluteModal
            type={type}
            refresh={refresh}
            title={title}
            id={id}
            message={message}
            actionText={mapSubmitTypeToText(submitType)}
            noButton={noButton}
            onClose={noButton ? () => {} : onAfterCancel}
          />
        );
        return;
      }

      // Delay is only applied to iOS Mobile app for now to avoid delaying unnecessarily
      // shouldDelay is used to indicate which components to add delay for (i.e. ideally only for concurrent Modal components)
      const shouldIOSDelay = shouldDelay && checkIsIos() && checkIsNative();

      // Need to unmount/hide the previous modal before displaying the alert
      removeGate(PORTAL_GATE_ALERT);

      const delayDuration = shouldIOSDelay ? customDelaySeconds : 0;
      // Delay added to allow previous modal to fully unmount/hide before displaying alert
      setTimeout(() => {
        teleportToGate(
          PORTAL_GATE_ALERT,
          <WebModal
            title={title}
            message={message}
            actionText={mapSubmitTypeToText(submitType)}
            noButton={noButton}
            onClose={noButton ? () => {} : onAfterCancel}
          />
        );
      }, delayDuration);
    }
  };
};

export { AlertManager };
